import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { getNextVoucherNumber } from '../../../query-api'

export const useNextVoucherNumber = () => {
  const { organization } = useUserOrganization()

  const { data, ...rest } = useQuery(
    [QueryKeys.NextVoucherNo, organization?.id],
    () => getNextVoucherNumber(organization?.id as string),
    {
      enabled: !!organization?.id,
      cacheTime: 0,
    },
  )

  return {
    nextVoucherNumber: data?.nextVoucherNo,
    ...rest,
  }
}
